import React from 'react';
import './style.scss';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Forms from '../../../molecules/forms';
import useTimeRangePicker from './hooks';

interface Props {
  id: string;
  label?: string | undefined;
  // eslint-disable-next-line no-unused-vars
  handleChangeStart: (e: Date| null) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeEnd: (e: Date| null) => void;
}

const TimeRangePicker: React.FC<Props> = (props) => {
  const {
    handleChangeEnd, handleChangeStart, id, label,
  } = props;
  const {
    show, setShow, endSelected, startSelected, setStartSelected, setEndSelected,
    timeConverter,
  } = useTimeRangePicker();

  return (
    <div className={id}>
      <label htmlFor={id} className={label ? 'label' : 'd-none'}>{label}</label>
      <div className="position-relative">
        <button
          type="button"
          className={show ? 'input-time-range-picker input-time-range-picker-active' : 'input-time-range-picker'}
          onClick={() => setShow(!show)}
        >
          <AccessTimeIcon style={{
            position: 'absolute',
            left: 15,
            top: 7,
            color: '#A6A6A6',
          }}
          />
          <div className="fz-14">{`${timeConverter(startSelected)} - ${timeConverter(endSelected)}`}</div>
          <div style={{
            position: 'absolute', right: 15, top: 8, color: show ? 'black' : 'silver',
          }}
          >
            {!show ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
          </div>
        </button>
        <div className={show ? 'optionContainer p-3' : 'd-none'}>
          <div className="row">
            <div className="col-lg-6 mb-lg-0 mb-4">
              <Forms.TimePicker
                id="startTime"
                selectedTime={startSelected}
                handleChange={(e) => {
                  if (e !== null) {
                    handleChangeStart(e);
                    setStartSelected(e);
                  }
                }}
                label="Start Time"
                maxTime={new Date(endSelected.getTime() - (10 * 60000))}
                minTime={new Date(0, 0, 0, 0, 0)}
              />
            </div>
            <div className="col-lg-6">
              <Forms.TimePicker
                id="endTime"
                selectedTime={endSelected}
                handleChange={(e) => {
                  if (e !== null) {
                    handleChangeEnd(e);
                    setEndSelected(e);
                  }
                }}
                minTime={new Date(startSelected.getTime() + (10 * 60000))}
                maxTime={new Date(0, 0, 0, 23, 50)}
                label="End Time"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeRangePicker;
